import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Hero } from './components/home/Hero';
import { HowItWorks } from './components/home/HowItWorks';
import { Packages } from './components/home/Packages';
import { Testimonials } from './components/home/Testimonials';
import { FAQ } from './components/home/FAQ';
import { GetStarted } from './pages/GetStarted';
import { LoginPage } from './pages/LoginPage';
import { UserDashboard } from './pages/UserDashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { validateFirebaseSetup } from './utils/firebase';
import { initializeDatabase } from './services/database/initialize';

function App() {
  useEffect(() => {
    const init = async () => {
      await validateFirebaseSetup();
      await initializeDatabase();
    };
    init();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <HowItWorks />
                <Packages />
                <Testimonials />
                <FAQ />
              </>
            } />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute requireAdmin>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;